import { Component, OnInit, ɵɵqueryRefresh } from '@angular/core';
import { Chart } from 'chart.js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {Location} from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { DatePipe } from '@angular/common'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'

@Component({
  selector: 'app-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.css']
})
export class AppointmentDetailsComponent implements OnInit {

  notesForm:FormGroup;
  fullName;
  email;
  phoneNumber;
  branch;
  userappointment=[];
  error=[];
allappointmentsDetails=[];
date;
perms=true;
success;
currentUser:User;
username;
userbranch;
role;
timeIn;
loggedInUserId;

worksheetDetails;

  constructor(private actroute: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private _authenticationService: AuthenticationService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private _appointment: AppointmentService,
    public datepipe: DatePipe) {
      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.loggedInUserId=this.currentUser.userName;
     
      this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
      this.userbranch=this.currentUser.branch;
      this.role=this.currentUser.role;
     }
     }

  ngOnInit(): void {

  
    this.actroute.paramMap.subscribe(params => {
      // This is never executed, for route is not recognized
      // let myArray=params.getAll('extra');
      const pid = params.get('extra')
      this.fullName = params.get('extra1')
      this.phoneNumber = params.get('extra2');
      this.branch = params.get('extra3');
      this.timeIn = params.get('extra4');
      //console.log(this.timeIn);
      if (pid) {
      //  console.log(this.fullName);
        this.getAppointmentToView(pid, this.fullName, this.phoneNumber,this.branch, this.timeIn);
       
      } else {
        //      this.viewMode=false;
      //  console.log('done');
      }
    });

       
  this.notesForm = this.fb.group({
    modalMsg: new FormControl(''),
    pid: new FormControl(''),
    clientID: new FormControl(''),
    fullName: new FormControl(''),
    notes: new FormControl(''),
    oldNotes: new FormControl(''),
    branch: new FormControl(''),
    actionPerformedBy: new FormControl(this.loggedInUserId)
  });


  }//End og NgOnInit



  openNotesModal(modal){

        var finalmessage= "Please enter your notes: "
      console.log(this.userappointment[0].notes, this.userappointment[0].fullName);
    
      this.modalService.open(modal, {
        centered: true,
        backdrop: 'static'
      });
    
      this.notesForm.patchValue({
        modalMsg: finalmessage,
        pid:this.userappointment[0].pid,
        clientID:this.userappointment[0].clientID,
        fullName: this.userappointment[0].fullName,
        oldNotes:this.userappointment[0].notes,
        branch: this.branch
      
        
       });
      
    }
/****************************************************************************** */
    saveNotes(){


  this._appointment.UpdateNotesForAppointment(this.notesForm.value)
        .subscribe(//subscribe to Observable
          response => {
        
            this.modalService.dismissAll();
            //console.log('Success!', response);
           
            this.notesForm.reset;
           this.refresh();
            
          },
          error => {
            this.modalService.dismissAll();
            //console.error('ERROR!', error);
            this.error = error.error.text;
            document.getElementById("openErrorModalButton").click();
          }
        );

    }

 
    /****************************************************************************** */
    openClientDetails(client){
console.log(client);
      this.router.navigate(['../client-details', { extra:client.clientID, extra1: client.fullName,extra2:client.phoneNumber,extra3:client.email}], { relativeTo: this.actroute });
     }   
    /****************************************************************************** */



  getAppointmentToView(pid, fullName,phoneNumber,branch, timeIn) {
    this._appointment.getUserAppointment(pid, fullName,phoneNumber,branch,timeIn).subscribe(

      response =>  {
        this.userappointment= response;
        console.log(this.userappointment);
      },
      (err) => {
        this.error = err;
      }
    );
  
  }

editAppointment(appointment){
  //console.log(appointment);
  if(appointment.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:appointment.pid,extra1:appointment.timeIn,extra2:appointment.salesRep,extra3:appointment.branch,extra4:appointment.timeIn}],{relativeTo:this.actroute});
  }else{
 
 
   this.router.navigate(['../appointment-edit',{extra:appointment.pid,extra1:appointment.fullName,extra2:appointment.phoneNumber,extra3:appointment.branch,extra4:appointment.timeIn}],{relativeTo:this.actroute});
  }
 }

 sendEmail(list){
  this._appointment.sendAppointmentEmailToClient(list)
  .subscribe(//subscribe to Observable
    response => {console.log('Success!', response);
    this.success=response['SUCCESS'];
        
    document.getElementById("openSuccessEmailSentModalButton").click();
    
  },
    error => {console.error('Error!', error);
    this.error=error.error.text ;
  }       
  );
}



inprogressAppointment(list){
  // console.log(list);
  list['status']="In Progress";
  this._appointment.setAppointmentStatusbypid(list)
   .subscribe(//subscribe to Observable
     response => {console.log('Success!', response);
     this.success=response['SUCCESS'];
         
     document.getElementById("openSuccessStatusUpdateModalButton").click();
     
   },
     error => {console.error('Error!', error);
     this.error=error.error.text ;
   }       
   );
 }


 cancelAppointment(list){
  // console.log(list);
  list['status']="Cancelled";
   this._appointment.setAppointmentStatusbypid(list)
   .subscribe(//subscribe to Observable
     response => {console.log('Success!', response);
     this.success=response['SUCCESS'];
         
     document.getElementById("openSuccessStatusUpdateModalButton").click();
     
   },
     error => {console.error('Error!', error);
     this.error=error.error.text ;
   }       
   );
 }

 completeAppointment(list){
   list['status']='Completed';
  this._appointment.setAppointmentStatusbypid(list)
  .subscribe(//subscribe to Observable
    response => {console.log('Success!', response);
    this.success=response['SUCCESS'];
        
    document.getElementById("openSuccessCompleteModalButton").click();
    
  },
    error => {console.error('Error!', error);
    this.error=error.error.text ;
  }       
  );
}

 
  
 deleteAppointment(list){
  list['actionPerformedBy']=this.loggedInUserId;
  list['role']=this.role;
  this._appointment.deleteAppointmentbypid(list)
  .subscribe(//subscribe to Observable
    response => {console.log('Success!', response);
    this.success=response['SUCCESS'];
       
    document.getElementById("openSuccessDeleteModalButton").click();
  },
    error => {console.error('Error!', error);
    this.error=error.error.text ;
  }       
  );
}


 patchCheckIn(){
  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');


}



patchCheckOut(){
  let dateTime = new Date();
  this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

  
}



  backClicked() {
    this._location.back();
  }



  refresh(): void {
    window.location.reload();
  }

  isAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.Administrator;
  }
  
  isSystemAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
  }
  
  isReceptionist() {
    return this.currentUser && this.currentUser.role === UserRole.Receptionist;
  }
  
  isSalesRep() {
    return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
  }
  
  isPowerUser() {
    return this.currentUser && this.currentUser.role === UserRole.PowerUser;
  }
  
}
